export default "__VITE_ASSET__CkSfOB0E__"